import { hasPermission } from '../utils/hasPermission';

export default {
  inserted(el, binding) {
    const { value } = binding;
    if (value && typeof value === 'string') {
      const hasPerm = hasPermission(value);
      if (!hasPerm) {
        // 无权限：移除元素
        // el.parentNode && el.parentNode.removeChild(el);
        // 无权限：禁用但保留显示
        el.disabled = true;
        el.classList.add('is-disabled');
      }
    }
  }
};